import React from 'react';

const OnVoardIcon = (props) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" id="onvoard-icon" viewBox="0 0 125 125"><path d="M106.9,379.5L76.8,455.6h-9L49.1,409H60.3l12.1,32.6,25.5-66.9A62.5,62.5,0,1,0,106.9,379.5Z" transform="translate(-10.7 -369.6)"/>
    </svg>

  );
}


export { OnVoardIcon };
